



























  import Vue from 'vue';
  import Component from 'vue-class-component';

  @Component({
    name: 'TransactionFinish',
    components: {},
    mixins: [],
  })
  export default class TransactionFinish extends Vue {
    public created(): void {
      // on componenet created
    }
    public mounted(): void {
      // on componenet mounted
    }
  }
